<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 18:16:10
 * @Description: 查看维保合同
-->
<template>
  <!-- 页面头部 Start -->

  <!-- 页面头部 End -->
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-60 o-dialog--xl-60 o-dialog-h--75"
    title="高危问题"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div class="l-page l-page--search">
      <p
        v-if="dlParams.type === 'edit'"
        class="o-tis"
      >
        对于单位评估，存在以下情形之一的直接判定为不合格
      </p>
      <p
        v-else
        class="o-tis"
      >
        评估单位存在以下高危情形，可直接判定为不合格
      </p>
      <!-- 页面主内容：查询列表 Start -->
      <div class="l-page__body l-page--search__body">
        <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
        <!-- table的ref的命名根据业务名称修改 -->
        <k-table
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="gwwtList"
          :pagination-show="false"
          :multiple="dlParams.type === 'edit'"
          @current-change="init"
          @selection-change="handleSelectionChange"
        >
          <template #gwwtMc="scope">
            <el-link
              :underline="false"
              type="primary"
            >
              {{ scope.row.gwwtMc }}
            </el-link>
          </template>
        </k-table>
      </div>
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        v-if="dlParams.type === 'edit'"
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { pgxmManageService } from '../pgxm.service.js';
export default {
  name: 'GwwtDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      xmid: null,

      loading: false, // 页面是否加载
      tableData: {
        rows: []
      },
      tableColumn: [
        { key: 'gwwtMc', slotName: 'gwwtMc', label: '问题', align: 'left', minWidth: '500', type: 'text' }
      ],
      fd: {
        id: []
      },
      // 查询条件
      filterParams: {
        name: null
      },
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */
      multipleSelectedRow: [], // 表格选中行（多选）
      gwwtList: [],
      xmGwwt: []
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      console.log(val);
      this.multipleSelectedRow = val;
    },
    /**
     * 初始化数据
     */
    init () {
      this.loading = true;
      pgxmManageService.gwwtListQuery()
        .then(rsp => {
          if (this.dlParams.type === 'edit') {
            this.gwwtList = rsp.data;
          }
          this.getPgxmInfoGwwt(rsp.data);
        })
        .catch(err => {
          console.error('获取高危问题信息错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 初始化该项目的高危问题数据
     */
    getPgxmInfoGwwt (_wtList) {
      const _this = this;
      pgxmManageService.gwwtXmQuery(_this.xmid)
        .then(rsp => {
          // 该项目初始没有高危问题，直接结束方法
          if (rsp.data.length <= 0) return;
          // 该项目的已存在的高温问题
          const _gwList = [];
          rsp.data.forEach(item => {
            const equalList = _wtList.filter(_item => _item.gwwtDm === item.gwwtDm);
            _gwList.push(equalList[0]);
          });
          if (_this.dlParams.type !== 'edit') {
            _this.gwwtList = _gwList;

            _this.$nextTick(() => {
              _this.$refs.kTable.doLayout();
            });
          } else {
            _this.$nextTick(() => {
              _this.toggleSelection(_gwList);
            });
          }
        })
        .catch(err => {
          console.error('该项目的高温问题信息查询错误', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * 初始化列表复选框
     */
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.kTable.toggleRowSelection(row);
        });
      }
    },
    /**
     * @description: 保存操作
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      this.$confirm('保存后，该项目评定为不合格、评分为0，确定保存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 遍历复选中选框内容，取高危问题id
        for (const key in this.multipleSelectedRow) {
          this.fd.id.push(this.multipleSelectedRow[key].gwwtDm);
        }
        pgxmManageService.gwwtSave(this.xmid, this.fd.id)
          .then(rsp => {
            this.$message({
              message: '保存成功！',
              type: 'success'
            });
            this.$emit('callback', this.multipleSelectedRow);
            this.$emit('closeDialog', '');
          }).catch(err => {
            console.error('保存高危问题错误！', err);
          });
      });
      this.loading = false;
    }

  },
  created () {
    this.xmid = this.dlParams.id;
    this.init();
  }
};

</script>
<style scoped>
.o-tis {
  margin: 10px 15px;
  color: rgb(255, 2, 2);
}
</style>
